export enum UsageType {
    Invoice = 'USAGE_TYPE_INVOICE',
    Address = 'USAGE_TYPE_DELIVERY',
    Both = 'USAGE_TYPE_BOTH',
}
